<template>
  <a-card class="content " :bordered="false">
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title">{{$route.query.name}}</span>
    <div class="m-t-20 s_flex_bian_c">
      <div class=" flex_1 s_FBFCFC m-r-140 m-l-40 s_flex_center s_flex_fdc height-160 item">
        <h4 class="s_fonts18" style="margintop: -10px">参与数量</h4>
        <div class="m-t-20 s_font_b s_fonts30">{{danum.store_number || 0}}</div>
      </div>
      <div class="flex_1 s_FBFCFC m-r-140 s_flex_center s_flex_fdc height-160 item">
        <h4 class="s_fonts18" style="margintop: -10px">完成数</h4>
        <div class="m-t-20 s_font_b s_fonts30">{{danum.complete_store_number || 0}}</div>
      </div>
      <div class="flex_1 s_FBFCFC m-r-40 s_flex_center s_flex_fdc height-160 item">
        <h4 class="s_fonts18" style="margintop: -10px">完成度</h4>
        <a-progress type="circle" class="m-t-10" :percent="percentage" :width="80" />
      </div>
    </div>
    <div class="m-t-80">
            <a-form ref='form' :model='search' class="m-b-20" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item v-if="$route.query.type==2" label="门店名称" name='store_name'>
          <a-input placeholder="请输入门店名称" style="width: 200px;" readonly v-model:value="search.store_name"></a-input>
          <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 5px;top: 13px;" v-if='search.store_name' @click='search.store_name="";search.range_id="";' />
        </a-form-item>
        <a-form-item v-if="$route.query.type==2">
          <a-button type="primary" @click="showStore=true">选择</a-button>
        </a-form-item>
            <a-form-item  v-if="$route.query.type==1" label="经销商" name='dealer_name'>
          <a-input placeholder="选择经销商" style="width: 200px;" readonly v-model:value="search.dealer_name"></a-input>
          <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 5px;top: 13px;" v-if='search.dealer_name' @click='search.dealer_name="";search.range_id=""' />
        </a-form-item>
        <a-form-item>
          <a-button v-if="$route.query.type==1"  type="primary" @click="visible=true">选择</a-button>
        </a-form-item>
        <a-form-item label="是否完成" name='is_complete'>
          <a-select v-model:value="search.is_complete" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">是</a-select-option>
            <a-select-option :value="0">否</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" ghost v-has:exaExport="exportTable">导出</a-button>
        </a-form-item>
      </a-form>
      <a-table v-if="$route.query.type==1" :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data' class='tableFixBox' :scroll="{ x: 'max-content'}">
      </a-table>
           <a-table v-if="$route.query.type==2" :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='storecolumns' :data-source='data' class='tableFixBox' :scroll="{ x: 'max-content'}">
      </a-table>
            <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </div>
      <a-modal :keyboard="false" title="选择门店" v-model:visible="showStore" centered :width='1200' destroyOnClose :footer="null">
        <!-- <selectChain v-on:select="storeSelect" :selectList='[{id:search.store_code}]'></selectChain> -->
           <selectStore :checkout='false' v-on:select="storeSelect" :selectList='[{id:search.range_id}]' :hiddenHead='true'></selectStore>
      </a-modal>
      <a-modal title="选择经销商" v-model:visible="visible" centered :width='1200' destroyOnClose :footer="null">
        <selectDealer :isSubDealer="true" v-on:select="dealerSelect" :mustShowHeadquarters='false'></selectDealer>
      </a-modal>
  </a-card>
</template>
<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { CloseCircleFilled } from "@ant-design/icons-vue";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
import { contractingtaskstatistics } from "@/api/guide";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  is_complete: "",
  dealer_name: "",
  range_id: "",
  store_name: "",
};
export default {
  components: {
    CloseCircleFilled,
  },
  setup(props) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    let danum = ref({});
    const $route = inject("$route");
    const $router = inject("$router");
    console.log($route.query.type);
    console.log($route.query.id);
    const state = reactive({
      visible: false,
      questionnaire_id: "",
      listLoading: false,
      total: 0,
      showStore: false,
      percentage:0,
    });
    let storecolumns = [
      {
        title: "门店编号",
        dataIndex: "code",
        key: "code",
      },
      {
        title: "门店名称",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "已签收数",
        dataIndex: "sign_in_number",
        key: "sign_in_number",
      },
      {
        title: "还需签收数",
        dataIndex: "surplus_number",
        key: "surplus_number",
      },
      {
        title: "是否完成",
        dataIndex: "is_complete_text",
        key: "is_complete_text",
      },
      {
        title: "完成度",
        dataIndex: "complete_scale",
        key: "complete_scale",
      },
    ];

    let columns = [
      {
        title: "经销商编号",
        dataIndex: "code",
        key: "code",
      },
      {
        title: "经销商名称",
        dataIndex: "name",
        key: "name",
        customRender: ({ record }) => {
          return record.name ? record.name : "-";
        },
      },
      {
        title: "已签收数",
        dataIndex: "sign_in_number",
        key: "sign_in_number",
        slots: { customRender: "sign_in_number" },
      },
      {
        title: "还需签收数",
        dataIndex: "surplus_number",
        key: "surplus_number",
      },
      {
        title: "是否完成",
        dataIndex: "is_complete_text",
        key: "is_complete_text",
      },
      {
        title: "完成度",
        dataIndex: "complete_scale",
        key: "complete_scale",
      },
    ];
    const $Modal = inject("$Modal");
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData();
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData();
    };
    // 导出
    const exportTable = async () => {
      let res = await contractingtaskstatistics({
        ...search.value,
        excel: 1,
        id: $route.query.id,
      }).then((res) => res.data);
      if (iscode(res)) {
        window.open(res.data.url);
      } else {
        message.error(res.message);
      }
    };
    //经销商选择
    const dealerSelect = (data) => {
      console.log(data);
      search.value.dealer_name = data.dealer_name;
      search.value.range_id = data.dealer_id;
      state.visible = false;
    };
    //选择门店
    const storeSelect = (data) => {
      console.log(data);
      search.value.store_name = data.store_name;
      search.value.range_id = data.id;
      state.showStore = false;
    };
    const initData = async () => {
      state.listLoading = true;
      let res = await contractingtaskstatistics({
        ...search.value,
        id: $route.query.id,
      })
        .then((res) => res.data)
        .catch((error) => error);
      state.listLoading = false;
      if (iscode(res)) {
        danum.value=res.data;
        var reg1 = new RegExp("%","g");
				state.percentage= danum.value.complete_scale.replace(reg1,'');
        data.value = res.data.data;
        state.total = res.data.total;
      } else {
        message.error(res.message);
      }
    };
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      initData,
      dealerSelect,
      exportTable,
      storecolumns,
      storeSelect,
      danum,
    };
  },
};
</script>

<style lang="less" scoped>
.item {
  box-shadow: 6px 8px 20px 0 rgba(0, 0, 0, 0.3);
  // inset -3px -2px 7px 0 rgb(0 0 0 / 30%)
  border-radius: 10px;
}
</style>
